import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useNavigation } from '@/contexts/NavigationContext';

/**
 * Syncs the browser URL with the active conversation.
 * - When activeConversationId changes → update URL to /chat/:id or /
 * - Avoids pushing duplicate entries
 */
export function UrlSync() {
  const { activeConversationId, navigation } = useNavigation();
  const navigate = useNavigate();
  const location = useLocation();
  const prevId = useRef<string | null>(null);

  useEffect(() => {
    // Only sync when on chat tab
    if (navigation.tab !== 'chat') {
      if (location.pathname !== '/app') {
        navigate('/app', { replace: true });
      }
      return;
    }

    const targetPath = activeConversationId
      ? `/app/chat/${activeConversationId}`
      : '/app';

    // Avoid redundant navigation
    if (location.pathname === targetPath) {
      prevId.current = activeConversationId;
      return;
    }

    // Use replace for the first sync (e.g. coming from /chat/:id route),
    // push for user-initiated conversation switches
    const isInitialSync = prevId.current === null && activeConversationId;
    navigate(targetPath, { replace: !!isInitialSync });
    prevId.current = activeConversationId;
  }, [activeConversationId, navigation.tab, navigate, location.pathname]);

  return null;
}
